import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createUnknownComponentVNode as _$cc } from 'intact-vue';
import { Input } from './';
import { Icon } from '../icon';
import { Button } from '../button';
import { getRestProps } from '../utils';
import { makeSearchStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    className = _this$get.className,
    placeholder = _this$get.placeholder,
    value = _this$get.value,
    type = _this$get.type,
    size = _this$get.size,
    open = _this$get.open;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-search"] = true, _classNameObj[className] = className, _classNameObj[k + "-open"] = open, _classNameObj[k + "-hide"] = !open, _classNameObj[k + "-" + type] = type, _classNameObj[makeSearchStyles(k)] = true, _classNameObj);
  return _$cv('form', _extends({}, getRestProps(this), {
    'className': _$cn(classNameObj),
    'ev-submit': this.onSubmit,
    'ref': this.elementRef
  }), [_$cc(Input, {
    'clearable': true,
    'ref': this.inputRef,
    'placeholder': open ? placeholder : undefined,
    'value': open ? value : undefined,
    'ev-$change:value': this.onChangeValue,
    'readonly': !open,
    'size': size,
    'waveDisabled': type !== 'default'
  }, null, this.inputRef), _$cc(Button, {
    'icon': true,
    'type': 'none',
    'ev-click': this.onClickBtn,
    'size': size,
    'children': _$cc(Icon, {
      'className': _$cn(k + "-icon-search " + k + "-search-icon")
    })
  })]);
}
;